module.exports = __webpack_public_path__ + "img/clock.def60af2.svg";